'use client'

import { useFetch } from "@hooks";
import { useLocalStore } from "@store/useLocalStore";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { FetchingWrapper } from "./FetchingWrapper";

export const Body = ({ children }) => {

    const router = useRouter();
    const pathname = usePathname();

    const { color, mode } = useLocalStore(state => state.theme);
    const role = useLocalStore(state => state.user.role);

    const [isHydrated, setIsHydrated] = useState(false);
   
    

    const [subscriptionData, subscriptionError, subscriptionLoading] = useFetch(isHydrated ? `${process.env.SERVER_ADRESS}/users/pop-up` : "");
    const isSubscribed = subscriptionData?.result;

    useEffect(() => {
        setIsHydrated(true)
    }, []);

    // useEffect(() => {
    //     if (role === "pros") {
    //         if ((pathname.startsWith("/pro") || (pathname.startsWith("/rendez-vous/visio"))) && subscriptionData && !isSubscribed) {
    //             router.push("/abonnement");
    //         }
    //     }
    // }, [pathname, subscriptionData]);


    // useEffect(() => {
    //     if (role === "pros" && subscriptionData) {
         
    //         if ((pathname.startsWith("/pro") || (pathname.startsWith("/rendez-vous/visio")))  && !isSubscribed) {
              
    //             router.push("/abonnement");
    //         }
    //     }
    // }, [pathname, subscriptionData, subscriptionLoading, isSubscribed, role]);



    useEffect(() => {
        const ready =
            role === "pros" &&
            subscriptionData !== undefined &&
            typeof isSubscribed === "boolean" &&
            !subscriptionLoading;
    
        if (!ready ) return;
    
        // if(subscriptionData?.message === 'Token invalide' && isSubscribed) {
        //     router.push("/connexion/login");
        //     return;
        // }

    
        if (
            (pathname.startsWith("/pro") || pathname.startsWith("/rendez-vous/visio")) &&
            !isSubscribed 
        
        ) {
        
            router.push("/abonnement");
        }
    }, [pathname, subscriptionData, subscriptionLoading, isSubscribed, role]);

    


    const pathnameExceptions = !pathname.startsWith("/pro") && !pathname.startsWith("/particulier");

    const themeClass = pathnameExceptions ? "theme-emerald" : `theme-${color}`;


    return (
        <>
            {isHydrated && !subscriptionLoading
                ?
                <body className={`${themeClass} theme-mode-${mode}`}>
                    {children}
                </body>
                :
                <body className="theme-emerald theme-mode-light">
                    <FetchingWrapper isLoading={subscriptionLoading} mainWrapper />
                </body>
            }
        </>
    )
}


